<template>
  <div>
    <FiltersWrapper>
      <CollapseBlock class="filters" tablet-mode>
        <div class="filters__item">
          <CustomSelect
            :options="this.residents"
            label="ЖК"
            optionValueKey="resident_id"
            optionLabelKey="resident_name"
            :value="this.filters.resident_id"
            :loading="this.residentsFetching"
            @change="(value) => onFiltersChange('resident_id', value)"
          />
        </div>
        <div class="filters__item">
          <CustomSelect
            :options="this.blocks"
            label="Блок"
            optionValueKey="block_id"
            optionLabelKey="block_name"
            :value="this.filters.block_id"
            :loading="this.blocksFetching"
            :disabled="!this.filters.resident_id"
            @change="(value) => onFiltersChange('block_id', value)"
          />
        </div>
        <div class="filters__item">
          <CustomSelect
            :options="this.workGroups"
            label="Конструктив"
            optionValueKey="work_group_id"
            optionLabelKey="work_group_name"
            :value="this.filters.work_group_id"
            :loading="this.workGroupsFetching"
            :disabled="!this.filters.block_id"
            @change="(value) => onFiltersChange('work_group_id', value)"
          />
        </div>
      </CollapseBlock>
    </FiltersWrapper>
    <div class="table-container tier-fact-table">
      <div v-if="!this.filters.work_group_id" class="no-data">
        Выберите конструктив для отображения данных
      </div>
      <div v-else-if="!this.isLevelNeed">
        <div class="table-header-with-nav">
          <q-btn
            flat
            dense
            round
            icon="chevron_left"
            size="md"
            :disable="!canGoBackward"
            @click="goBackward"
            class="nav-btn"
            title="Добавить день слева"
          />
          <span class="table-title">Факт работ</span>
          <q-btn
            flat
            dense
            round
            icon="chevron_right"
            size="md"
            :disable="!canGoForward"
            @click="goForward"
            class="nav-btn"
            title="Добавить день справа"
          />
        </div>
        <div class="table-wrapper" ref="tableWrapperNoLevel">
          <CustomTable
            :rowsData="this.rowsData"
            :columns="this.workTaskFactColumns"
            :loading="isFetching"
            :small="true"
            :striped="false"
            :customBody="true"
            :customHeader="true"
            :allWidth="false"
          >
        <template #customHeader="props">
          <!-- Строка 1: Месяцы -->
          <q-tr>
            <q-th rowspan="3" class="task-name-header">Задача</q-th>
            <q-th rowspan="3" class="unit-name-header" align="center">Ед. изм.</q-th>
            <template v-for="(monthGroup, groupIndex) in this.displayedMonthGroups" :key="groupIndex">
              <q-th
                v-if="groupIndex > 0"
                rowspan="3"
                class="month-divider"
              ></q-th>
              <q-th
                :colspan="monthGroup.dates.length * 2 + 2"
                class="month-header"
              >
                {{ monthGroup.monthName }} {{ monthGroup.year }}
              </q-th>
            </template>
          </q-tr>
          <!-- Строка 2: Дни + Итого месяца -->
          <q-tr>
            <template v-for="(monthGroup, groupIndex) in this.displayedMonthGroups" :key="groupIndex">
              <q-th
                v-for="dateInfo in monthGroup.dates"
                :key="dateInfo.original"
                colspan="2"
                align="center"
                :class="['day-header', { 'day-header--month-first': isFirstDateInMonth(dateInfo.original, monthGroup), 'day-header--month-last': isLastDateInMonth(dateInfo.original, monthGroup) }]"
              >
                {{ dateInfo.day }}
              </q-th>
              <q-th colspan="2" align="center" class="month-total-header">
                Итого {{ monthGroup.monthName }}
              </q-th>
            </template>
          </q-tr>
          <!-- Строка 3: П/Ф -->
          <q-tr>
            <template v-for="(monthGroup, groupIndex) in this.displayedMonthGroups" :key="groupIndex">
              <template v-for="dateInfo in monthGroup.dates" :key="dateInfo.original">
                <q-th align="center" class="plan-fact-header plan-header">П</q-th>
                <q-th align="center" class="plan-fact-header fact-header">Ф</q-th>
              </template>
              <q-th align="center" class="plan-fact-header plan-header">
                <q-icon name="event_note" size="18px" />
              </q-th>
              <q-th align="center" class="plan-fact-header fact-header">
                <q-icon name="check_circle" size="18px" />
              </q-th>
            </template>
          </q-tr>
        </template>
        <template #customBody="props">
          <q-tr :class="getRowClass(props.row)">
            <q-td class="task-name-cell" align="left">
              {{ props.row.task_name }}
            </q-td>
            <q-td class="unit-name-cell" align="center">
              {{ props.row.unit_name || '-' }}
            </q-td>
                    <!-- Специальная обработка для строки этажности -->
                    <template v-if="props.row.task_name === 'Этажность'">
                      <template v-for="(monthGroup, groupIndex) in this.displayedMonthGroups" :key="groupIndex">
                        <!-- Разделитель месяцев (кроме первого) -->
                        <q-td
                          v-if="groupIndex > 0"
                          class="month-divider-cell"
                        ></q-td>
                        
                        <!-- Этажи для дней месяца -->
                        <template v-for="(floorSegment, segmentIndex) in getFloorSegmentsForMonth(props.row, monthGroup)" :key="segmentIndex">
                          <q-td
                            v-if="floorSegment.type === 'floor'"
                            :colspan="floorSegment.colspan * 2"
                            align="center"
                            :class="['date-cell', { 'floor-cell': floorSegment.floorNum !== null, 'floor-cell-empty': floorSegment.floorNum === null }]"
                            :style="floorSegment.floorNum !== null ? { backgroundColor: getFloorColor(floorSegment.floorNum) } : {}"
                          >
                            <span v-if="floorSegment.floorNum !== null" class="floor-label">
                              {{ floorSegment.floorNum }} <span class="floor-word">этаж</span>
                            </span>
                            <span v-else class="text-grey-5">-</span>
                          </q-td>
                        </template>
                        
                        <!-- Пустые ячейки для "Итого месяц" (этажи не рисуются здесь) -->
                        <q-td colspan="2" class="month-total-cell" align="center">-</q-td>
                      </template>
                    </template>
                    <!-- Обычная обработка для остальных строк -->
                    <template v-else>
                      <template v-for="(monthGroup, groupIndex) in this.displayedMonthGroups" :key="groupIndex">
                        <q-td
                          v-if="groupIndex > 0"
                          class="month-divider-cell"
                        ></q-td>
                        <template v-for="dateInfo in monthGroup.dates" :key="dateInfo.original">
                          <!-- Для строки ГПР: одна объединённая ячейка -->
                          <template v-if="props.row.task_name === 'Отклонение от ГПР (+/-)'">
                            <q-td
                              colspan="2"
                              align="center"
                              :class="['date-cell', { 'clickable-cell': props.row.is_edit !== false, 'non-editable-cell': props.row.is_edit === false, 'date-cell--today': isToday(dateInfo.original), 'date-cell--month-first': isFirstDateInMonth(dateInfo.original, monthGroup), 'date-cell--month-last': isLastDateInMonth(dateInfo.original, monthGroup) }]"
                              @click="props.row.is_edit !== false ? handleCellClick(props.row, dateInfo.original, props.row[dateInfo.original]) : null"
                            >
                              <div
                                v-if="props.row[dateInfo.original] && props.row[dateInfo.original].length > 0"
                                class="gpr-cell-content"
                              >
                                <div
                                  v-for="(item, index) in props.row[dateInfo.original]"
                                  :key="index"
                                  :class="['gpr-value', {
                                    'gpr-ahead': item.plan_value > 0,
                                    'gpr-on-schedule': item.plan_value == 0,
                                    'gpr-behind': item.plan_value < 0
                                  }]"
                                >
                                  {{ item.plan_value !== null && item.plan_value !== undefined && item.plan_value !== '' ? item.plan_value : '-' }}
                                </div>
                              </div>
                              <span v-else class="text-grey-5">-</span>
                            </q-td>
                          </template>
                          <!-- Для остальных строк: две ячейки План и Факт -->
                          <template v-else>
                            <!-- Ячейка План -->
                            <q-td
                              align="center"
                              :class="['date-cell', 'plan-column', { 'clickable-cell': props.row.is_edit !== false, 'non-editable-cell': props.row.is_edit === false, 'date-cell--today': isToday(dateInfo.original), 'date-cell--month-first': isFirstDateInMonth(dateInfo.original, monthGroup) }]"
                              @click="props.row.is_edit !== false ? handleCellClick(props.row, dateInfo.original, props.row[dateInfo.original]) : null"
                            >
                              <div class="date-cell-content-vertical">
                                <template v-if="props.row[dateInfo.original] && props.row[dateInfo.original].length > 0">
                                  <div
                                    v-for="(item, index) in props.row[dateInfo.original]"
                                    :key="index"
                                    class="plan-fact-grid"
                                  >
                                    <div 
                                      class="grid-cell plan-cell" 
                                      title="План"
                                      @click.stop="props.row.is_edit !== false ? handleCellClick(props.row, dateInfo.original, props.row[dateInfo.original]) : null"
                                      style="cursor: pointer;"
                                    >
                                      {{ item.plan_value !== null && item.plan_value !== undefined && item.plan_value !== '' ? item.plan_value : '-' }}
                                    </div>
                                    <div class="grid-cell plan-cell" title="Задолженность предыдущих дней">
                                      {{ item.delta !== null && item.delta !== undefined ? item.delta : '-' }}
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <div class="plan-fact-grid">
                                    <div 
                                      class="grid-cell plan-cell" 
                                      title="План"
                                      @click.stop="props.row.is_edit !== false ? handleCellClick(props.row, dateInfo.original, props.row[dateInfo.original]) : null"
                                      style="cursor: pointer;"
                                    >-</div>
                                    <div class="grid-cell plan-cell" title="Задолженность предыдущих дней">-</div>
                                  </div>
                                </template>
                              </div>
                            </q-td>
                            
                            <!-- Ячейка Факт -->
                            <q-td
                              align="center"
                              :class="['date-cell', 'fact-column', { 'clickable-cell': props.row.is_edit !== false, 'non-editable-cell': props.row.is_edit === false, 'date-cell--today': isToday(dateInfo.original), 'date-cell--month-last': isLastDateInMonth(dateInfo.original, monthGroup) }]"
                              @click="props.row.is_edit !== false ? handleCellClick(props.row, dateInfo.original, props.row[dateInfo.original]) : null"
                            >
                              <div class="date-cell-content-vertical">
                                <template v-if="props.row[dateInfo.original] && props.row[dateInfo.original].length > 0">
                                  <div
                                    v-for="(item, index) in props.row[dateInfo.original]"
                                    :key="index"
                                    class="plan-fact-grid"
                                  >
                                    <div 
                                      class="grid-cell fact-cell"
                                      title="Факт этого дня"
                                      :class="{ 
                                        'fact-red': item.plan_value > item.fact_value_new,
                                        'fact-green': item.plan_value <= item.fact_value_new && item.fact_value_new !== null && item.fact_value_new !== undefined
                                      }"
                                    >
                                      {{ item.fact_value_new !== null && item.fact_value_new !== undefined ? item.fact_value_new : '-' }}
                                    </div>
                                    <div 
                                      class="grid-cell fact-cell"
                                      title="Факт выполнения задолженности"
                                      :class="{ 
                                        'fact-red': item.delta > item.fact_dept_value,
                                        'fact-green': item.delta <= item.fact_dept_value && item.fact_dept_value !== null && item.fact_dept_value !== undefined && item.fact_dept_value !== 0,
                                        'fact-grey': item.fact_dept_value === 0
                                      }"
                                    >
                                      {{ item.fact_dept_value !== null && item.fact_dept_value !== undefined ? item.fact_dept_value : '-' }}
                                    </div>
                                  </div>
                                </template>
                                <template v-else>
                                  <div class="plan-fact-grid">
                                    <div class="grid-cell fact-cell" title="Факт этого дня">-</div>
                                    <div class="grid-cell fact-cell" title="Факт выполнения задолженности">-</div>
                                  </div>
                                </template>
                              </div>
                            </q-td>
                          </template>
                        </template>
                        <!-- Итого за месяц -->
                        <template v-if="props.row.task_name === 'Отклонение от ГПР (+/-)'">
                          <q-td colspan="2" class="month-total-cell gpr-total-cell" align="center"
                            :class="{
                              'gpr-ahead': getMonthPlanSum(props.row, monthGroup) > 0,
                              'gpr-on-schedule': getMonthPlanSum(props.row, monthGroup) == 0,
                              'gpr-behind': getMonthPlanSum(props.row, monthGroup) < 0
                            }"
                          >
                            {{ getMonthPlanSum(props.row, monthGroup) }}
                          </q-td>
                        </template>
                        <template v-else>
                          <q-td class="month-total-cell report-plan-cell" align="center">
                            {{ getMonthPlanSum(props.row, monthGroup) }}
                          </q-td>
                          <q-td class="month-total-cell report-fact-cell" align="center">
                            {{ getMonthFactSum(props.row, monthGroup) }}
                          </q-td>
                        </template>
                      </template>
                    </template>
                  </q-tr>
        </template>
      </CustomTable>
        </div>
      </div>
      <div v-else-if="this.isLevelNeed && this.levelTabs.length > 0" class="levels-accordion">
        <q-list>
          <q-expansion-item
            v-for="levelTab in this.levelTabs"
            :key="levelTab.work_group_level_id"
            :label="levelTab.level_num_display"
            :header-class="'level-accordion-header'"
            expand-separator
            @show="() => onLevelExpand(levelTab.work_group_level_id)"
          >
          <div class="level-table-container tier-fact-table">
            <div v-if="levelTab.loading" class="level-loading">
              <q-spinner color="primary" size="3em" />
            </div>
            <div v-else-if="!levelTab.rowsData || levelTab.rowsData.length === 0" class="no-data">
              Нет данных для этого этажа
              <div style="font-size: 12px; margin-top: 10px; color: #666;">
                Debug: loaded={{ levelTab.loaded }}, rowsData.length={{ levelTab.rowsData?.length || 0 }}, monthGroups.length={{ levelTab.monthGroups?.length || 0 }}
              </div>
            </div>
            <div v-else>
              <div class="table-header-with-nav">
                <q-btn
                  flat
                  dense
                  round
                  icon="chevron_left"
                  size="md"
                  :disable="!canGoBackwardForLevel(levelTab)"
                  @click="() => goBackwardForLevel(levelTab)"
                  class="nav-btn"
                  title="Добавить день слева"
                />
                <span class="table-title">Факт работ</span>
                <q-btn
                  flat
                  dense
                  round
                  icon="chevron_right"
                  size="md"
                  :disable="!canGoForwardForLevel(levelTab)"
                  @click="() => goForwardForLevel(levelTab)"
                  class="nav-btn"
                  title="Добавить день справа"
                />
              </div>
              <div class="table-wrapper" :ref="`tableWrapperLevel_${levelTab.work_group_level_id}`">
                <CustomTable
                  :rowsData="levelTab.rowsData || []"
                  :columns="levelTab.columns || []"
                  :loading="false"
                  :small="true"
                  :striped="false"
                  :customBody="true"
                  :customHeader="true"
                  :allWidth="false"
                >
                <template #customHeader="props">
                  <!-- Строка 1: Месяцы -->
                  <q-tr>
                    <q-th rowspan="3" class="task-name-header">Задача</q-th>
                    <q-th rowspan="3" class="unit-name-header" align="center">Ед. изм.</q-th>
                    <template v-for="(monthGroup, groupIndex) in getDisplayedMonthGroupsForLevel(levelTab)" :key="groupIndex">
                      <q-th
                        v-if="groupIndex > 0"
                        rowspan="3"
                        class="month-divider"
                      ></q-th>
                      <q-th
                        :colspan="monthGroup.dates.length * 2 + 2"
                        class="month-header"
                      >
                        {{ monthGroup.monthName }} {{ monthGroup.year }}
                      </q-th>
                    </template>
                  </q-tr>
                  <!-- Строка 2: Дни + Итого месяца -->
                  <q-tr>
                    <template v-for="(monthGroup, groupIndex) in getDisplayedMonthGroupsForLevel(levelTab)" :key="groupIndex">
                      <q-th
                        v-for="dateInfo in monthGroup.dates"
                        :key="dateInfo.original"
                        colspan="2"
                        align="center"
                        :class="['day-header', { 'day-header--month-first': isFirstDateInMonth(dateInfo.original, monthGroup), 'day-header--month-last': isLastDateInMonth(dateInfo.original, monthGroup) }]"
                      >
                        {{ dateInfo.day }}
                      </q-th>
                      <q-th colspan="2" align="center" class="month-total-header">
                        Итого {{ monthGroup.monthName }}
                      </q-th>
                    </template>
                  </q-tr>
                  <!-- Строка 3: П/Ф -->
                  <q-tr>
                    <template v-for="(monthGroup, groupIndex) in getDisplayedMonthGroupsForLevel(levelTab)" :key="groupIndex">
                      <template v-for="dateInfo in monthGroup.dates" :key="dateInfo.original">
                        <q-th align="center" class="plan-fact-header plan-header">П</q-th>
                        <q-th align="center" class="plan-fact-header fact-header">Ф</q-th>
                      </template>
                      <q-th align="center" class="plan-fact-header plan-header">
                        <q-icon name="event_note" size="18px" />
                      </q-th>
                      <q-th align="center" class="plan-fact-header fact-header">
                        <q-icon name="check_circle" size="18px" />
                      </q-th>
                    </template>
                  </q-tr>
                </template>
                <template #customBody="props">
                  <q-tr :class="getRowClass(props.row)">
                    <q-td class="task-name-cell" align="left">
                      {{ props.row.task_name }}
                    </q-td>
                    <q-td class="unit-name-cell" align="center">
                      {{ props.row.unit_name || '-' }}
                    </q-td>
                    <template v-for="(monthGroup, groupIndex) in getDisplayedMonthGroupsForLevel(levelTab)" :key="groupIndex">
                      <q-td
                        v-if="groupIndex > 0"
                        class="month-divider-cell"
                      ></q-td>
                      <template v-for="dateInfo in monthGroup.dates" :key="dateInfo.original">
                        <!-- Для строки ГПР: одна объединённая ячейка -->
                        <template v-if="props.row.task_name === 'Отклонение от ГПР (+/-)'">
                          <q-td
                            colspan="2"
                            align="center"
                            :class="['date-cell', { 'clickable-cell': props.row.is_edit !== false, 'non-editable-cell': props.row.is_edit === false, 'date-cell--today': isToday(dateInfo.original), 'date-cell--month-first': isFirstDateInMonth(dateInfo.original, monthGroup), 'date-cell--month-last': isLastDateInMonth(dateInfo.original, monthGroup) }]"
                            @click="props.row.is_edit !== false ? handleCellClick(props.row, dateInfo.original, props.row[dateInfo.original], levelTab.work_group_level_id) : null"
                          >
                            <div
                              v-if="props.row[dateInfo.original] && props.row[dateInfo.original].length > 0"
                              class="gpr-cell-content"
                            >
                              <div
                                v-for="(item, index) in props.row[dateInfo.original]"
                                :key="index"
                                :class="['gpr-value', {
                                  'gpr-ahead': item.plan_value > 0,
                                  'gpr-on-schedule': item.plan_value == 0,
                                  'gpr-behind': item.plan_value < 0
                                }]"
                              >
                                {{ item.plan_value !== null && item.plan_value !== undefined && item.plan_value !== '' ? item.plan_value : '-' }}
                              </div>
                            </div>
                            <span v-else class="text-grey-5">-</span>
                          </q-td>
                        </template>
                        <!-- Для остальных строк: две ячейки План и Факт -->
                        <template v-else>
                          <!-- Ячейка План -->
                          <q-td
                            align="center"
                            :class="['date-cell', 'plan-column', { 'clickable-cell': props.row.is_edit !== false, 'non-editable-cell': props.row.is_edit === false, 'date-cell--today': isToday(dateInfo.original), 'date-cell--month-first': isFirstDateInMonth(dateInfo.original, monthGroup) }]"
                            @click="props.row.is_edit !== false ? handleCellClick(props.row, dateInfo.original, props.row[dateInfo.original], levelTab.work_group_level_id) : null"
                          >
                            <div class="date-cell-content-vertical">
                              <template v-if="props.row[dateInfo.original] && props.row[dateInfo.original].length > 0">
                                <div
                                  v-for="(item, index) in props.row[dateInfo.original]"
                                  :key="index"
                                  class="plan-fact-grid"
                                >
                                  <div 
                                    class="grid-cell plan-cell" 
                                    title="План"
                                    @click.stop="props.row.is_edit !== false ? handleCellClick(props.row, dateInfo.original, props.row[dateInfo.original], levelTab.work_group_level_id) : null"
                                    style="cursor: pointer;"
                                  >
                                    {{ item.plan_value !== null && item.plan_value !== undefined && item.plan_value !== '' ? item.plan_value : '-' }}
                                  </div>
                                  <div class="grid-cell plan-cell" title="Задолженность предыдущих дней">
                                    {{ item.delta !== null && item.delta !== undefined ? item.delta : '-' }}
                                  </div>
                                </div>
                              </template>
                              <template v-else>
                                <div class="plan-fact-grid">
                                  <div 
                                    class="grid-cell plan-cell" 
                                    title="План"
                                    @click.stop="props.row.is_edit !== false ? handleCellClick(props.row, dateInfo.original, props.row[dateInfo.original], levelTab.work_group_level_id) : null"
                                    style="cursor: pointer;"
                                  >-</div>
                                  <div class="grid-cell plan-cell" title="Задолженность предыдущих дней">-</div>
                                </div>
                              </template>
                            </div>
                          </q-td>
                          
                          <!-- Ячейка Факт -->
                          <q-td
                            align="center"
                            :class="['date-cell', 'fact-column', { 'clickable-cell': props.row.is_edit !== false, 'non-editable-cell': props.row.is_edit === false, 'date-cell--today': isToday(dateInfo.original), 'date-cell--month-last': isLastDateInMonth(dateInfo.original, monthGroup) }]"
                            @click="props.row.is_edit !== false ? handleCellClick(props.row, dateInfo.original, props.row[dateInfo.original], levelTab.work_group_level_id) : null"
                          >
                            <div class="date-cell-content-vertical">
                              <template v-if="props.row[dateInfo.original] && props.row[dateInfo.original].length > 0">
                                <div
                                  v-for="(item, index) in props.row[dateInfo.original]"
                                  :key="index"
                                  class="plan-fact-grid"
                                >
                                  <div 
                                    class="grid-cell fact-cell"
                                    title="Факт этого дня"
                                    :class="{ 
                                      'fact-red': item.plan_value > item.fact_value_new,
                                      'fact-green': item.plan_value <= item.fact_value_new && item.fact_value_new !== null && item.fact_value_new !== undefined
                                    }"
                                  >
                                    {{ item.fact_value_new !== null && item.fact_value_new !== undefined ? item.fact_value_new : '-' }}
                                  </div>
                                  <div 
                                    class="grid-cell fact-cell"
                                    title="Факт выполнения задолженности"
                                    :class="{ 
                                      'fact-red': item.delta > item.fact_dept_value,
                                      'fact-green': item.delta <= item.fact_dept_value && item.fact_dept_value !== null && item.fact_dept_value !== undefined && item.fact_dept_value !== 0,
                                      'fact-grey': item.fact_dept_value === 0
                                    }"
                                  >
                                    {{ item.fact_dept_value !== null && item.fact_dept_value !== undefined ? item.fact_dept_value : '-' }}
                                  </div>
                                </div>
                              </template>
                              <template v-else>
                                <div class="plan-fact-grid">
                                  <div class="grid-cell fact-cell" title="Факт этого дня">-</div>
                                  <div class="grid-cell fact-cell" title="Факт выполнения задолженности">-</div>
                                </div>
                              </template>
                            </div>
                          </q-td>
                        </template>
                      </template>
                      <!-- Итого за месяц -->
                      <template v-if="props.row.task_name === 'Отклонение от ГПР (+/-)'">
                        <q-td colspan="2" class="month-total-cell gpr-total-cell" align="center"
                          :class="{
                            'gpr-ahead': getMonthPlanSum(props.row, monthGroup) > 0,
                            'gpr-on-schedule': getMonthPlanSum(props.row, monthGroup) == 0,
                            'gpr-behind': getMonthPlanSum(props.row, monthGroup) < 0
                          }"
                        >
                          {{ getMonthPlanSum(props.row, monthGroup) }}
                        </q-td>
                      </template>
                      <template v-else>
                        <q-td class="month-total-cell report-plan-cell" align="center">
                          {{ getMonthPlanSum(props.row, monthGroup) }}
                        </q-td>
                        <q-td class="month-total-cell report-fact-cell" align="center">
                          {{ getMonthFactSum(props.row, monthGroup) }}
                        </q-td>
                      </template>
                    </template>
                  </q-tr>
                </template>
              </CustomTable>
              </div>
            </div>
          </div>
          </q-expansion-item>
        </q-list>
      </div>
      <div v-else-if="this.isLevelNeed && this.levelTabs.length === 0 && !isFetching" class="no-data">
        Нет этажей для отображения
      </div>
    </div>
  </div>
</template>

<script>
import CustomSelect from "@/components/form/CustomSelect";
import CollapseBlock from "@/components/common/CollapseBlock";
import FiltersWrapper from "@/components/common/FiltersWrapper";
import CustomTable from "@/components/common/CustomTable";
import { getResidents, getBlocks, getWorkGroups, getWorkTaskFact, getWorkTaskFactColumns, updateWorkTaskFact, deleteWorkTaskFact, getWorkGroupLevelNum, getGprValues } from "./services";
import { normalizeDateString, dateToIso, addDaysIso, generateAllMonthGroups } from "../TierPlan/services";
import { MODAL_NAMES } from "@/constants";
import { useAppStore } from "@/services/store/app";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";

export default {
  name: "TierFact",
  components: { CustomSelect, CollapseBlock, FiltersWrapper, CustomTable },
  data() {
    return {
      workTaskFactColumns: [],
      rowsData: [],
      monthGroups: [],
      allDates: [], // Все доступные даты из всех месяцев
      visibleStartIndex: 0, // Индекс первой видимой даты
      visibleEndIndex: 8, // Индекс последней видимой даты (начальное окно 9 дней: -7, текущая, +1)
      levelTabs: [], // Массив этажей с данными для аккордеона
      isLevelNeed: false,
      isFetching: false,
      isLoadingGpr: false, // Флаг загрузки ГПР для предотвращения дублирования
      gprRequestCounter: 0, // Счетчик запросов ГПР для предотвращения race condition
      residents: [],
      blocks: [],
      workGroups: [],
      residentsFetching: false,
      blocksFetching: false,
      workGroupsFetching: false,
      filters: {
        resident_id: '',
        block_id: '',
        work_group_id: '',
        work_group_level_id: '',
      },
      stickyUpdateTimeout: null,
      resizeHandlerBound: null,
      measuredSticky: {
        unit: 50,
      },
    }
  },
  computed: {
    // Текущая дата в формате YYYY-MM-DD
    todayDate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    // Видимые даты для отображения
    visibleDates() {
      if (!this.allDates || this.allDates.length === 0) return [];
      const start = Math.max(0, this.visibleStartIndex);
      const end = Math.min(this.allDates.length, this.visibleEndIndex + 1);
      return this.allDates.slice(start, end);
    },
    // Отображаемые месяцы для видимых дат (группируем по месяцам)
    displayedMonthGroups() {
      if (!this.visibleDates || this.visibleDates.length === 0) return [];
      
      const monthGroups = [];
      let currentMonthKey = null;
      let currentGroup = null;
      
      this.visibleDates.forEach(dateInfo => {
        const monthKey = `${dateInfo.year}-${dateInfo.month}`;
        if (currentMonthKey !== monthKey || currentGroup === null) {
          if (currentGroup) {
            monthGroups.push(currentGroup);
          }
          currentMonthKey = monthKey;
          currentGroup = {
            month: dateInfo.month,
            monthName: dateInfo.monthName,
            year: dateInfo.year,
            dates: []
          };
        }
        currentGroup.dates.push(dateInfo);
      });
      if (currentGroup) {
        monthGroups.push(currentGroup);
      }
      
      return monthGroups;
    },
    // Можно ли добавить день слева
    canGoBackward() {
      return this.visibleStartIndex > 0;
    },
    // Можно ли добавить день справа
    canGoForward() {
      return this.allDates && this.visibleEndIndex < this.allDates.length - 1;
    },
  },
  async mounted() {
    await this.loadResidents();
    // Загружаем фильтры из URL после загрузки резидентов
    await this.loadFiltersFromURL();
    if (typeof window !== 'undefined') {
      this.resizeHandlerBound = () => this.scheduleStickyUpdate();
      window.addEventListener('resize', this.resizeHandlerBound, { passive: true });
    }
  },
  beforeUnmount() {
    if (typeof window !== 'undefined' && this.resizeHandlerBound) {
      window.removeEventListener('resize', this.resizeHandlerBound);
      this.resizeHandlerBound = null;
    }
    if (this.stickyUpdateTimeout) {
      clearTimeout(this.stickyUpdateTimeout);
      this.stickyUpdateTimeout = null;
    }
  },
  methods: {
    async loadResidents() {
      this.residentsFetching = true;
      const res = await getResidents();
      this.residentsFetching = false;
      this.residents = res || [];
    },
    async loadBlocks(resident_id) {
      if (!resident_id) {
        this.blocks = [];
        return;
      }
      this.blocksFetching = true;
      const res = await getBlocks(resident_id);
      this.blocksFetching = false;
      this.blocks = res || [];
    },
    async loadWorkGroups(block_id) {
      if (!block_id) {
        this.workGroups = [];
        this.rowsData = [];
        return;
      }
      this.workGroupsFetching = true;
      const res = await getWorkGroups(block_id);
      this.workGroupsFetching = false;
      this.workGroups = res || [];
      // Не выбираем автоматически конструктив - пользователь должен выбрать его вручную
      // Если конструктивы загружены, но текущий work_group_id не входит в список, сбрасываем
      if (this.workGroups.length > 0) {
        const isCurrentValid = this.workGroups.some(wg => wg.work_group_id === this.filters.work_group_id);
        if (!isCurrentValid) {
          this.filters.work_group_id = '';
          this.rowsData = [];
        }
      } else {
        this.filters.work_group_id = '';
        this.rowsData = [];
      }
    },
    async loadWorkTaskFact(work_group_id) {
      if (!work_group_id) {
        this.rowsData = [];
        this.workTaskFactColumns = [];
        this.monthGroups = [];
        this.levelTabs = [];
        this.isLevelNeed = false;
        this.filters.work_group_level_id = '';
        return;
      }
      
      // Всегда загружаем данные в одной таблице без группировки по этажам
      this.isLevelNeed = false;
      this.levelTabs = [];
      this.filters.work_group_level_id = '';
      
      // Загружаем все данные без фильтрации по этажам
      await this.loadWorkTaskFactData(work_group_id, null);
    },
    async loadLevelTabs(work_group_id) {
      try {
        // Загружаем только список этажей (метаданные), без данных
        // Данные будут загружены только при раскрытии конкретного этажа в onLevelExpand
        const res = await getWorkGroupLevelNum(work_group_id);
        const levelData = res || [];
        
        // Формируем список этажей для аккордеона (без загрузки данных)
        this.levelTabs = levelData.map((item) => {
          const workGroupLevelId = item.work_group_level_id;
          const levelNum = item.level_num;
          
          // Если нет work_group_level_id, создаем ключ из level_num и дат
          let levelId = workGroupLevelId;
          if (!levelId || levelId === null || levelId === undefined) {
            const dateStart = item.level_date_start || item.date_start;
            const dateEnd = item.level_date_end || item.date_end;
            if (dateStart && dateEnd && levelNum !== null && levelNum !== undefined) {
              levelId = `level_${levelNum}_${dateStart}_${dateEnd}`;
            } else {
              levelId = levelNum !== null && levelNum !== undefined ? `level_${levelNum}` : '__null__';
            }
          }
          
          return {
            work_group_level_id: levelId,
            level_num: levelNum,
            level_num_display: levelNum !== null && levelNum !== undefined ? `Этаж ${levelNum}` : 'Без этажа',
            loading: false,
            rowsData: [],
            columns: [],
            monthGroups: [],
            allDates: [], // Все доступные даты
            visibleStartIndex: 0, // Индекс первой видимой даты
            visibleEndIndex: 8, // Индекс последней видимой даты
            loaded: false, // Флаг, что данные уже загружены
            isLoadingGpr: false, // Флаг загрузки ГПР для этого уровня
          };
        }).sort((a, b) => {
          // Сортируем по убыванию level_num, чтобы этажи шли снизу вверх
          // (последний этаж вверху списка, 1 этаж внизу списка)
          const numA = a.level_num !== null && a.level_num !== undefined ? a.level_num : -Infinity;
          const numB = b.level_num !== null && b.level_num !== undefined ? b.level_num : -Infinity;
          return numB - numA;
        });
      } catch (e) {
        console.error('Error loading level tabs:', e);
        this.levelTabs = [];
      }
    },
    async onLevelExpand(work_group_level_id) {
      // Этот метод вызывается только при раскрытии конкретного этажа
      const levelTab = this.levelTabs.find(tab => tab.work_group_level_id === work_group_level_id);
      if (!levelTab) {
        console.error('Level tab not found:', work_group_level_id);
        return;
      }
      
      if (levelTab.loaded) {
        // Данные уже загружены для этого этажа, не загружаем повторно
        return;
      }
      
      if (!this.filters.work_group_id) {
        console.error('work_group_id is not set');
        levelTab.loading = false;
        return;
      }
      
      // Загружаем данные только для раскрытого этажа
      levelTab.loading = true;
      try {
        await this.loadWorkTaskFactDataForLevel(this.filters.work_group_id, work_group_level_id, levelTab);
      } catch (e) {
        console.error('Error loading level data:', e);
        levelTab.loading = false;
      }
    },
    async loadWorkTaskFactDataForLevel(work_group_id, work_group_level_id, levelTab) {
      if (!work_group_id || !levelTab) {
        levelTab.loading = false;
        return;
      }
      
      try {
        // Загружаем данные для определения минимальной даты с данными
        const res = await getWorkTaskFact(work_group_id, work_group_level_id);
        const groupedData = res?.data || [];
        
        // Определяем минимальную дату с данными
        let firstDateWithData = null;
        const flatData = [];
        groupedData.forEach((group) => {
          if (group.items && Array.isArray(group.items) && group.items.length > 0) {
            group.items.forEach((item) => {
              const normalizedDate = normalizeDateString(item.work_date || item.plan_date || item.fact_date);
              if (normalizedDate) {
                flatData.push({
                  ...item,
                  work_date: normalizedDate,
                });
              }
            });
          }
        });
        
        const datesWithData = flatData
          .filter((item) => {
            const hasPlan = item.plan_value !== null && item.plan_value !== undefined && item.plan_value !== '';
            const hasFact = item.fact_value !== null && item.fact_value !== undefined && item.fact_value !== '';
            return (hasPlan || hasFact) && item.work_date;
          })
          .map((item) => item.work_date)
          .filter(Boolean);
        
        if (datesWithData.length > 0) {
          const sortedDatesWithData = [...new Set(datesWithData)].sort((a, b) =>
            a.localeCompare(b)
          );
          firstDateWithData = sortedDatesWithData[0];
        }
        
        // Создаем все месяцы сразу
        const startDate = firstDateWithData || dateToIso(new Date());
        const startDateWithPast = addDaysIso(startDate, -365);
        const endDate = addDaysIso(startDate, 10 * 365);
        levelTab.monthGroups = generateAllMonthGroups(startDateWithPast, endDate);
        
        // Собираем все даты из всех месяцев в один массив
        levelTab.allDates = [];
        levelTab.monthGroups.forEach(monthGroup => {
          monthGroup.dates.forEach(dateInfo => {
            levelTab.allDates.push(dateInfo);
          });
        });
        
        // Определяем начальный диапазон: текущая дата -7 дней и +1 день
        let todayIndex = -1;
        if (levelTab.allDates.length > 0) {
          todayIndex = levelTab.allDates.findIndex(d => d.original === this.todayDate);
          if (todayIndex < 0) {
            // Если текущей даты нет в списке, ищем ближайшую дату
            todayIndex = Math.floor(levelTab.allDates.length / 2);
          }
        }
        
        // Устанавливаем начальное окно: -7 дней от текущей даты, +1 день вперед (итого 9 дней)
        levelTab.visibleStartIndex = Math.max(0, todayIndex - 7);
        levelTab.visibleEndIndex = Math.min(levelTab.allDates.length - 1, todayIndex + 1);
        
        // Загружаем данные для всех дат (матрица уже содержит все данные)
        await this.loadAllDataForLevel(work_group_id, work_group_level_id, levelTab, groupedData);
        
        levelTab.loaded = true;
        levelTab.loading = false;
        this.scheduleStickyUpdate();
      } catch (e) {
        console.error('Error loading work task fact data for level:', e);
        levelTab.monthGroups = [];
        levelTab.allDates = [];
        levelTab.visibleStartIndex = 0;
        levelTab.visibleEndIndex = 8;
        levelTab.loading = false;
        this.scheduleStickyUpdate();
      }
    },
    async loadAllDataForLevel(work_group_id, work_group_level_id, levelTab, groupedData) {
      if (!work_group_id || !levelTab) return;
      
      try {
        // Обрабатываем все данные сразу
        const flatData = [];
        groupedData.forEach((group) => {
          if (group.items && Array.isArray(group.items) && group.items.length > 0) {
            group.items.forEach((item) => {
              const normalizedDate = normalizeDateString(item.work_date || item.plan_date || item.fact_date);
              if (normalizedDate) {
                flatData.push({
                  ...item,
                  task_name_group: group.task_name,
                  work_date: normalizedDate,
                });
              }
            });
          }
        });
        
        const uniqueTaskNames = [];
        groupedData.forEach((group) => {
          if (group.task_name && !uniqueTaskNames.includes(group.task_name)) {
            uniqueTaskNames.push(group.task_name);
          }
        });
        
        const taskDictMap = {};
        const unitNameMap = {};
        const isEditMap = {};
        const taskDateMap = {};
        
        groupedData.forEach((group) => {
          const taskName = group.task_name;
          if (!taskName) return;
          if (group.task_dict_id && !taskDictMap[taskName]) {
            taskDictMap[taskName] = group.task_dict_id;
          }
          if (group.unit_name && !unitNameMap[taskName]) {
            unitNameMap[taskName] = group.unit_name;
          }
          isEditMap[taskName] = group.is_edit !== undefined ? group.is_edit : true;
        });
        
        flatData.forEach((item) => {
          const taskName = item.task_name || item.task_name_group;
          if (!taskName || !item.work_date) return;
          if (!taskDateMap[taskName]) {
            taskDateMap[taskName] = {};
          }
          if (!taskDateMap[taskName][item.work_date]) {
            taskDateMap[taskName][item.work_date] = [];
          }
          taskDateMap[taskName][item.work_date].push(item);
        });
        
        // Создаем матрицу для всех дат
        const rowsData = uniqueTaskNames.map((taskName) => {
          const row = {
            task_name: taskName,
            task_dict_id: taskDictMap[taskName] || null,
            unit_name: unitNameMap[taskName] || null,
            is_edit: isEditMap[taskName] !== undefined ? isEditMap[taskName] : true,
          };
          
          // Добавляем данные для всех дат
          levelTab.allDates.forEach((dateInfo) => {
            row[dateInfo.original] = taskDateMap[taskName]?.[dateInfo.original] || [];
          });
          
          return row;
        });
        
        levelTab.rowsData = rowsData;
        
        // Формируем колонки для видимых дат
        this.updateColumnsForLevel(levelTab);
        
        // Добавляем строку ГПР для видимых дат
        await this.addGprRowForVisibleDatesLevel(work_group_id, work_group_level_id, levelTab);
        
        this.scheduleStickyUpdate();
      } catch (e) {
        console.error('Error loading all data for level:', e);
        levelTab.rowsData = [];
        levelTab.columns = [];
      }
    },
    async loadWorkTaskFactData(work_group_id, work_group_level_id) {
      if (!work_group_id) {
        this.rowsData = [];
        this.workTaskFactColumns = [];
        this.monthGroups = [];
        this.allDates = [];
        this.visibleStartIndex = 0;
        this.visibleEndIndex = 0;
        return;
      }
      
      this.isFetching = true;
      try {
        const res = await getWorkTaskFact(work_group_id, work_group_level_id);
        this.rowsData = res.matrix || [];
        this.monthGroups = res.monthGroups || [];
        
        // Собираем все даты из всех месяцев в один массив
        this.allDates = [];
        this.monthGroups.forEach(monthGroup => {
          monthGroup.dates.forEach(dateInfo => {
            this.allDates.push(dateInfo);
          });
        });
        
        // Определяем начальный диапазон на основе этажей или плана
        await this.setInitialVisibleRange(work_group_id);
        
        // Формируем колонки для видимых дат
        this.updateColumnsForVisibleDates();
        
        // Добавляем строку ГПР для видимых дат
        await this.addGprRowForVisibleDates(work_group_id, work_group_level_id);
        
        // Добавляем строку этажности
        await this.addFloorsRow(work_group_id);
        
        this.scheduleStickyUpdate();
        
        // Скроллим таблицу к началу (левому краю)
        this.$nextTick(() => {
          const wrapper = this.$refs.tableWrapperNoLevel;
          if (wrapper) {
            wrapper.scrollLeft = 0;
          }
        });
      } catch (e) {
        console.error('Error loading work task fact data:', e);
        this.rowsData = [];
        this.monthGroups = [];
        this.allDates = [];
        this.workTaskFactColumns = [];
        this.visibleStartIndex = 0;
        this.visibleEndIndex = 0;
      } finally {
        this.isFetching = false;
        this.scheduleStickyUpdate();
      }
    },
    onFiltersChange(key, value) {
      const editedObject = {
        [key]: value,
      };

      if (key === 'resident_id') {
        editedObject.block_id = '';
        editedObject.work_group_id = '';
        if (!!value) {
          this.loadBlocks(value);
        } else {
          this.blocks = [];
          this.workGroups = [];
        }
      }

      if (key === 'block_id') {
        editedObject.work_group_id = '';
        if (!!value) {
          this.loadWorkGroups(value);
        } else {
          this.workGroups = [];
        }
      }

      if (key === 'work_group_id') {
        this.loadWorkTaskFact(value);
      }

      this.filters = {
        ...this.filters,
        ...editedObject,
      };
      
      // Обновляем URL с текущими фильтрами
      this.updateURLWithFilters();
    },
    // Обновление URL с текущими фильтрами
    updateURLWithFilters() {
      const query = {};
      if (this.filters.resident_id) {
        query.resident_id = this.filters.resident_id;
      }
      if (this.filters.block_id) {
        query.block_id = this.filters.block_id;
      }
      if (this.filters.work_group_id) {
        query.work_group_id = this.filters.work_group_id;
      }
      
      // Обновляем URL без перезагрузки страницы
      this.$router.replace({ query }).catch(() => {});
    },
    // Загрузка фильтров из URL при монтировании
    async loadFiltersFromURL() {
      const { resident_id, block_id, work_group_id } = this.$route.query;
      
      if (resident_id) {
        this.filters.resident_id = parseInt(resident_id);
        await this.loadBlocks(this.filters.resident_id);
        
        if (block_id) {
          this.filters.block_id = parseInt(block_id);
          await this.loadWorkGroups(this.filters.block_id);
          
          if (work_group_id) {
            this.filters.work_group_id = parseInt(work_group_id);
            await this.loadWorkTaskFact(this.filters.work_group_id);
          }
        }
      }
    },
    handleCellClick(row, date, items, work_group_level_id = null) {
      // Проверяем, разрешено ли редактирование
      if (row.is_edit === false) {
        return;
      }
      
      // Получаем первый элемент или создаем пустой объект для новой записи
      const item = items && items.length > 0 ? items[0] : null;
      
      // Получаем информацию о блоке и конструктиве
      const selectedBlock = this.blocks.find(b => b.block_id === this.filters.block_id);
      const selectedWorkGroup = this.workGroups.find(wg => wg.work_group_id === this.filters.work_group_id);
      
      // Получаем task_dict_id из строки (он теперь хранится в row.task_dict_id)
      const task_dict_id = row.task_dict_id || null;
      
      // Сохраняем work_group_level_id для обновления данных после сохранения
      const currentLevelId = work_group_level_id || this.filters.work_group_level_id;
      
      this.showModal(MODAL_NAMES.EditTierFact, {
        title: 'Факт',
        block_name: selectedBlock?.block_name || '',
        work_group_name: selectedWorkGroup?.work_group_name || '',
        work_group_id: this.filters.work_group_id,
        task_name: row.task_name,
        task_dict_id: task_dict_id,
        fact_date: date,
        fact_value: item?.fact_value || '',
        work_task_fact_id: item?.work_task_fact_id || null,
        work_group_level_id: currentLevelId, // Передаем work_group_level_id в модалку
        debug_info: {
          work_group_id: this.filters.work_group_id,
          task_dict_id: task_dict_id,
          work_group_level_id: currentLevelId,
          date_: date
        },
        onSubmit: (formData) => this.onSubmitFact(formData, currentLevelId),
        onDelete: (deleteData) => this.onDeleteFact(deleteData, currentLevelId)
      });
    },
    async onSubmitFact(formData, work_group_level_id = null) {
      try {
        // При создании (work_task_fact_id = null) все обязательные поля должны быть переданы
        // fact_value может быть пустой строкой, но не null при создании
        const data = {
          work_task_fact_id: formData.work_task_fact_id || null,
          work_group_id: formData.work_group_id,
          task_dict_id: formData.task_dict_id || null,
          fact_date: formData.fact_date,
          fact_value: formData.fact_value !== null && formData.fact_value !== undefined ? formData.fact_value : null,
          work_group_level_id: formData.work_group_level_id || work_group_level_id || null
        };
        
        await updateWorkTaskFact(data);
        this.showSucceedSnackbar();
        this.closeModal();
        // Тихо обновляем данные после сохранения (без loader'а)
        const levelId = work_group_level_id || this.filters.work_group_level_id;
        if (this.isLevelNeed && levelId) {
          const levelTab = this.levelTabs.find(tab => tab.work_group_level_id === levelId);
          if (levelTab) {
            // Тихо перезагружаем данные для этого этажа без сброса состояния
            await this.reloadLevelDataSilently(levelTab);
          }
        } else if (!this.isLevelNeed) {
          // Тихо перезагружаем данные без loader'а
          await this.reloadDataSilently();
        }
      } catch (e) {
        console.error('Error updating fact:', e);
      }
    },
    async onDeleteFact(deleteData, work_group_level_id = null) {
      try {
        await deleteWorkTaskFact(deleteData);
        this.showSucceedSnackbar();
        this.closeModal();
        // Тихо обновляем данные после удаления (без loader'а)
        const levelId = work_group_level_id || this.filters.work_group_level_id;
        if (this.isLevelNeed && levelId) {
          const levelTab = this.levelTabs.find(tab => tab.work_group_level_id === levelId);
          if (levelTab) {
            // Тихо перезагружаем данные для этого этажа без сброса состояния
            await this.reloadLevelDataSilently(levelTab);
          }
        } else if (!this.isLevelNeed) {
          // Тихо перезагружаем данные без loader'а
          await this.reloadDataSilently();
        }
      } catch (e) {
        console.error('Error deleting fact:', e);
      }
    },
    getRowClass(row) {
      // Проверяем, является ли это строкой ГПР
      if (row && row.task_name === 'Отклонение от ГПР (+/-)') {
        return 'gpr-row';
      }
      // Проверяем, является ли это строкой этажности
      if (row && row.task_name === 'Этажность') {
        return 'floors-row';
      }
      return '';
    },
    getFloorSegments(floorsRow) {
      // Вычисляем сегменты этажей для всех видимых дат с учетом разделителей месяцев
      if (!floorsRow) return [];
      
      const segments = [];
      
      let currentFloor = null;
      let currentColspan = 0;
      
      this.displayedMonthGroups.forEach((monthGroup, groupIndex) => {
        // Добавляем разделитель месяцев (кроме первого)
        // На границе месяцев этаж всегда разбивается, даже если номер этажа тот же
        if (groupIndex > 0) {
          if (currentColspan > 0) {
            segments.push({
              type: 'floor',
              floorNum: currentFloor,
              colspan: currentColspan
            });
            currentColspan = 0;
            currentFloor = null; // Сбрасываем текущий этаж на границе месяцев
          }
          
          segments.push({ type: 'divider' });
        }
        
        monthGroup.dates.forEach((dateInfo) => {
          const dateItems = floorsRow[dateInfo.original];
          const floorNum = (dateItems && dateItems.length > 0 && dateItems[0].plan_value !== null && dateItems[0].plan_value !== undefined && dateItems[0].plan_value !== '') 
            ? dateItems[0].plan_value 
            : null;
          
          if (floorNum === currentFloor) {
            currentColspan++;
          } else {
            if (currentColspan > 0) {
              segments.push({
                type: 'floor',
                floorNum: currentFloor,
                colspan: currentColspan
              });
            }
            
            currentFloor = floorNum;
            currentColspan = 1;
          }
        });
      });
      
      if (currentColspan > 0) {
        segments.push({
          type: 'floor',
          floorNum: currentFloor,
          colspan: currentColspan
        });
      }
      
      return segments;
    },
    getFloorSegmentsForMonth(floorsRow, monthGroup) {
      // Вычисляем сегменты этажей только для одного месяца (без итоговых колонок)
      if (!floorsRow || !monthGroup || !monthGroup.dates) return [];
      
      const segments = [];
      let currentFloor = null;
      let currentColspan = 0;
      
      monthGroup.dates.forEach((dateInfo) => {
        const dateItems = floorsRow[dateInfo.original];
        const floorNum = (dateItems && dateItems.length > 0 && dateItems[0].plan_value !== null && dateItems[0].plan_value !== undefined && dateItems[0].plan_value !== '') 
          ? dateItems[0].plan_value 
          : null;
        
        if (floorNum === currentFloor) {
          currentColspan++;
        } else {
          if (currentColspan > 0) {
            segments.push({
              type: 'floor',
              floorNum: currentFloor,
              colspan: currentColspan
            });
          }
          
          currentFloor = floorNum;
          currentColspan = 1;
        }
      });
      
      if (currentColspan > 0) {
        segments.push({
          type: 'floor',
          floorNum: currentFloor,
          colspan: currentColspan
        });
      }
      
      return segments;
    },
    getFloorColor(floorNum) {
      // Чередуем цвета строго по номеру этажа
      // 1, 3, 5, 7... — оранжевый
      // 2, 4, 6, 8... — серый
      if (floorNum === null || floorNum === undefined || floorNum === '') {
        return '#FF6600'; // по умолчанию оранжевый
      }
      
      // Извлекаем число из значения (на случай если там "1 этаж" или просто "1")
      const numericValue = parseInt(String(floorNum).replace(/[^0-9]/g, ''), 10);
      
      if (!Number.isFinite(numericValue) || numericValue === 0) {
        return '#FF6600'; // по умолчанию оранжевый
      }
      
      // Чередуем: нечётные этажи (1,3,5...) — оранжевый, чётные (2,4,6...) — серый
      const colors = ['#FF6600', '#BDBDBD']; // оранжевый, серый
      return colors[(numericValue - 1) % 2];
    },
    getFloorNumber(floorNum) {
      // Извлекаем только число из значения, убирая скобки с датами и другой текст
      if (floorNum === null || floorNum === undefined || floorNum === '') {
        return '';
      }
      
      // Извлекаем первое число из строки (убираем всё кроме цифр, берём первое число)
      const numericValue = parseInt(String(floorNum).replace(/[^0-9]/g, ''), 10);
      
      if (!Number.isFinite(numericValue) || numericValue === 0) {
        return '';
      }
      
      return numericValue;
    },
    // Проверка, является ли дата сегодняшней
    isToday(date) {
      return date === this.todayDate;
    },
    // Проверка, является ли дата первой в месяце
    isFirstDateInMonth(date, monthGroup) {
      return monthGroup && monthGroup.dates && monthGroup.dates.length > 0 && monthGroup.dates[0].original === date;
    },
    // Проверка, является ли дата последней в месяце
    isLastDateInMonth(date, monthGroup) {
      return monthGroup && monthGroup.dates && monthGroup.dates.length > 0 && monthGroup.dates[monthGroup.dates.length - 1].original === date;
    },
    async goBackward() {
      if (this.canGoBackward) {
        this.visibleStartIndex = this.visibleStartIndex - 1;
        this.updateColumnsForVisibleDates();
        
        // Обновляем строку ГПР для новых видимых дат
        await this.addGprRowForVisibleDates(this.filters.work_group_id, null);
        
        // Обновляем строку этажности
        await this.addFloorsRow(this.filters.work_group_id);
        
        this.scheduleStickyUpdate();
        // Скроллим таблицу максимально влево
        this.$nextTick(() => {
          const wrapper = this.$refs.tableWrapperNoLevel;
          if (wrapper) {
            wrapper.scrollLeft = 0;
          }
        });
      }
    },
    async goForward() {
      if (this.canGoForward) {
        this.visibleEndIndex = this.visibleEndIndex + 1;
        this.updateColumnsForVisibleDates();
        
        // Обновляем строку ГПР для новых видимых дат
        await this.addGprRowForVisibleDates(this.filters.work_group_id, null);
        
        // Обновляем строку этажности
        await this.addFloorsRow(this.filters.work_group_id);
        
        this.scheduleStickyUpdate();
        // Скроллим таблицу вправо (к концу)
        this.$nextTick(() => {
          const wrapper = this.$refs.tableWrapperNoLevel;
          if (wrapper) {
            wrapper.scrollLeft = wrapper.scrollWidth;
          }
        });
      }
    },
    updateColumnsForVisibleDates() {
      // Обновляем колонки для видимых дат
      const displayedMonthGroups = this.displayedMonthGroups;
      const displayedDates = [];
      displayedMonthGroups.forEach(monthGroup => {
        monthGroup.dates.forEach(dateInfo => {
          displayedDates.push(dateInfo.original);
        });
      });
      this.workTaskFactColumns = getWorkTaskFactColumns(displayedDates, displayedMonthGroups);
    },
    async reloadDataSilently() {
      // Тихое обновление данных без loader'а (для режима без этажей)
      try {
        const res = await getWorkTaskFact(this.filters.work_group_id, null);
        // Просто обновляем данные матрицы
        this.rowsData = res.matrix || [];
        
        // Обновляем строку ГПР для видимых дат
        await this.addGprRowForVisibleDates(this.filters.work_group_id, null);
        
        // Обновляем строку этажности
        await this.addFloorsRow(this.filters.work_group_id);
        
        // Не трогаем monthGroups и видимый диапазон - они остаются теми же
      } catch (e) {
        console.error('Error silently reloading data:', e);
      }
    },
    async reloadLevelDataSilently(levelTab) {
      // Тихое обновление данных без loader'а (для режима с этажами)
      if (!levelTab || !this.filters.work_group_id) return;
      
      try {
        const res = await getWorkTaskFact(this.filters.work_group_id, levelTab.work_group_level_id);
        const groupedData = res?.data || [];
        
        // Обрабатываем все данные сразу
        const flatData = [];
        groupedData.forEach((group) => {
          if (group.items && Array.isArray(group.items) && group.items.length > 0) {
            group.items.forEach((item) => {
              const normalizedDate = normalizeDateString(item.work_date || item.plan_date || item.fact_date);
              if (normalizedDate) {
                flatData.push({
                  ...item,
                  task_name_group: group.task_name,
                  work_date: normalizedDate,
                });
              }
            });
          }
        });
        
        const uniqueTaskNames = [];
        groupedData.forEach((group) => {
          if (group.task_name && !uniqueTaskNames.includes(group.task_name)) {
            uniqueTaskNames.push(group.task_name);
          }
        });
        
        const taskDictMap = {};
        const unitNameMap = {};
        const isEditMap = {};
        const taskDateMap = {};
        
        groupedData.forEach((group) => {
          const taskName = group.task_name;
          if (!taskName) return;
          if (group.task_dict_id && !taskDictMap[taskName]) {
            taskDictMap[taskName] = group.task_dict_id;
          }
          if (group.unit_name && !unitNameMap[taskName]) {
            unitNameMap[taskName] = group.unit_name;
          }
          isEditMap[taskName] = group.is_edit !== undefined ? group.is_edit : true;
        });
        
        flatData.forEach((item) => {
          const taskName = item.task_name || item.task_name_group;
          if (!taskName || !item.work_date) return;
          if (!taskDateMap[taskName]) {
            taskDateMap[taskName] = {};
          }
          if (!taskDateMap[taskName][item.work_date]) {
            taskDateMap[taskName][item.work_date] = [];
          }
          taskDateMap[taskName][item.work_date].push(item);
        });
        
        // Создаем матрицу для всех дат
        const rowsData = uniqueTaskNames.map((taskName) => {
          const row = {
            task_name: taskName,
            task_dict_id: taskDictMap[taskName] || null,
            unit_name: unitNameMap[taskName] || null,
            is_edit: isEditMap[taskName] !== undefined ? isEditMap[taskName] : true,
          };
          
          // Добавляем данные для всех дат
          levelTab.allDates.forEach((dateInfo) => {
            row[dateInfo.original] = taskDateMap[taskName]?.[dateInfo.original] || [];
          });
          
          return row;
        });
        
        // Просто обновляем данные матрицы
        levelTab.rowsData = rowsData;
        
        // Обновляем строку ГПР для видимых дат
        await this.addGprRowForVisibleDatesLevel(this.filters.work_group_id, levelTab.work_group_level_id, levelTab);
        
        // Не трогаем columns, monthGroups, allDates, видимый диапазон - они остаются теми же
      } catch (e) {
        console.error('Error silently reloading level data:', e);
      }
    },
    getVisibleDatesForLevel(levelTab) {
      if (!levelTab || !levelTab.allDates || levelTab.allDates.length === 0) return [];
      const start = Math.max(0, levelTab.visibleStartIndex);
      const end = Math.min(levelTab.allDates.length, levelTab.visibleEndIndex + 1);
      return levelTab.allDates.slice(start, end);
    },
    getDisplayedMonthGroupsForLevel(levelTab) {
      const visibleDates = this.getVisibleDatesForLevel(levelTab);
      if (!visibleDates || visibleDates.length === 0) return [];
      
      const monthGroups = [];
      let currentMonthKey = null;
      let currentGroup = null;
      
      visibleDates.forEach(dateInfo => {
        const monthKey = `${dateInfo.year}-${dateInfo.month}`;
        if (currentMonthKey !== monthKey || currentGroup === null) {
          if (currentGroup) {
            monthGroups.push(currentGroup);
          }
          currentMonthKey = monthKey;
          currentGroup = {
            month: dateInfo.month,
            monthName: dateInfo.monthName,
            year: dateInfo.year,
            dates: []
          };
        }
        currentGroup.dates.push(dateInfo);
      });
      if (currentGroup) {
        monthGroups.push(currentGroup);
      }
      
      return monthGroups;
    },
    canGoBackwardForLevel(levelTab) {
      if (!levelTab) return false;
      return levelTab.visibleStartIndex > 0;
    },
    canGoForwardForLevel(levelTab) {
      if (!levelTab || !levelTab.allDates) return false;
      return levelTab.visibleEndIndex < levelTab.allDates.length - 1;
    },
    async goBackwardForLevel(levelTab) {
      if (this.canGoBackwardForLevel(levelTab)) {
        levelTab.visibleStartIndex = levelTab.visibleStartIndex - 1;
        this.updateColumnsForLevel(levelTab);
        
        // Обновляем строку ГПР для новых видимых дат
        await this.addGprRowForVisibleDatesLevel(this.filters.work_group_id, levelTab.work_group_level_id, levelTab);
        
        this.scheduleStickyUpdate();
        // Скроллим таблицу максимально влево
        this.$nextTick(() => {
          const refName = `tableWrapperLevel_${levelTab.work_group_level_id}`;
          const wrapper = this.$refs[refName];
          if (wrapper) {
            // ref может быть массивом, если есть несколько элементов с одинаковым ref
            const element = Array.isArray(wrapper) ? wrapper[0] : wrapper;
            if (element) {
              element.scrollLeft = 0;
            }
          }
        });
      }
    },
    async goForwardForLevel(levelTab) {
      if (this.canGoForwardForLevel(levelTab)) {
        levelTab.visibleEndIndex = levelTab.visibleEndIndex + 1;
        this.updateColumnsForLevel(levelTab);
        
        // Обновляем строку ГПР для новых видимых дат
        await this.addGprRowForVisibleDatesLevel(this.filters.work_group_id, levelTab.work_group_level_id, levelTab);
        
        this.scheduleStickyUpdate();
        // Скроллим таблицу вправо (к концу)
        this.$nextTick(() => {
          const refName = `tableWrapperLevel_${levelTab.work_group_level_id}`;
          const wrapper = this.$refs[refName];
          if (wrapper) {
            // ref может быть массивом, если есть несколько элементов с одинаковым ref
            const element = Array.isArray(wrapper) ? wrapper[0] : wrapper;
            if (element) {
              element.scrollLeft = element.scrollWidth;
            }
          }
        });
      }
    },
    updateColumnsForLevel(levelTab) {
      if (!levelTab) return;
      const displayedMonthGroups = this.getDisplayedMonthGroupsForLevel(levelTab);
      const displayedDates = [];
      displayedMonthGroups.forEach(monthGroup => {
        monthGroup.dates.forEach(dateInfo => {
          displayedDates.push(dateInfo.original);
        });
      });
      levelTab.columns = getWorkTaskFactColumns(displayedDates, displayedMonthGroups);
    },
    getTaskPlanSum(row) {
      if (!row) return '-';
      
      // Для строки ГПР возвращаем значение за текущий день
      if (row.task_name === 'Отклонение от ГПР (+/-)') {
        const todayData = row[this.todayDate];
        if (todayData && Array.isArray(todayData) && todayData.length > 0) {
          const planValue = todayData[0].plan_value;
          if (planValue !== null && planValue !== undefined && planValue !== '') {
            return planValue;
          }
        }
        return 0;
      }
      
      // Для остальных строк считаем сумму
      let sum = 0;
      let hasValue = false;
      
      // Проходим по всем свойствам строки, которые являются датами
      Object.keys(row).forEach(key => {
        // Пропускаем служебные поля
        if (key === 'task_name' || key === 'task_dict_id' || key === 'unit_name' || key === 'is_edit') {
          return;
        }
        
        const items = row[key];
        if (Array.isArray(items) && items.length > 0) {
          items.forEach(item => {
            const planValue = item.plan_value;
            if (planValue !== null && planValue !== undefined && planValue !== '') {
              const numValue = parseFloat(planValue);
              if (!isNaN(numValue)) {
                sum += numValue;
                hasValue = true;
              }
            }
          });
        }
      });
      
      return hasValue ? sum.toFixed(2).replace(/\.?0+$/, '') : '-';
    },
    getTaskFactSum(row) {
      if (!row) return '-';
      
      // Для строки ГПР возвращаем значение за текущий день
      if (row.task_name === 'Отклонение от ГПР (+/-)') {
        const todayData = row[this.todayDate];
        if (todayData && Array.isArray(todayData) && todayData.length > 0) {
          const planValue = todayData[0].plan_value;
          if (planValue !== null && planValue !== undefined && planValue !== '') {
            return planValue;
          }
        }
        return 0;
      }
      
      // Для остальных строк считаем сумму
      let sum = 0;
      let hasValue = false;
      
      // Проходим по всем свойствам строки, которые являются датами
      Object.keys(row).forEach(key => {
        // Пропускаем служебные поля
        if (key === 'task_name' || key === 'task_dict_id' || key === 'unit_name' || key === 'is_edit') {
          return;
        }
        
        const items = row[key];
        if (Array.isArray(items) && items.length > 0) {
          items.forEach(item => {
            const factValue = item.fact_value;
            if (factValue !== null && factValue !== undefined && factValue !== '') {
              const numValue = parseFloat(factValue);
              if (!isNaN(numValue)) {
                sum += numValue;
                hasValue = true;
              }
            }
          });
        }
      });
      
      return hasValue ? sum.toFixed(2).replace(/\.?0+$/, '') : '-';
    },
    getMonthPlanSum(row, monthGroup) {
      if (!row || !monthGroup || !monthGroup.dates) return '-';
      
      let sum = 0;
      let hasValue = false;
      
      monthGroup.dates.forEach(dateInfo => {
        const items = row[dateInfo.original];
        if (Array.isArray(items) && items.length > 0) {
          items.forEach(item => {
            const planValue = item.plan_value;
            if (planValue !== null && planValue !== undefined && planValue !== '') {
              const numValue = parseFloat(planValue);
              if (!isNaN(numValue)) {
                sum += numValue;
                hasValue = true;
              }
            }
          });
        }
      });
      
      return hasValue ? sum.toFixed(2).replace(/\.?0+$/, '') : '-';
    },
    getMonthFactSum(row, monthGroup) {
      if (!row || !monthGroup || !monthGroup.dates) return '-';
      
      let sum = 0;
      let hasValue = false;
      
      monthGroup.dates.forEach(dateInfo => {
        const items = row[dateInfo.original];
        if (Array.isArray(items) && items.length > 0) {
          items.forEach(item => {
            const factValue = item.fact_value_new;
            if (factValue !== null && factValue !== undefined && factValue !== '') {
              const numValue = parseFloat(factValue);
              if (!isNaN(numValue)) {
                sum += numValue;
                hasValue = true;
              }
            }
          });
        }
      });
      
      return hasValue ? sum.toFixed(2).replace(/\.?0+$/, '') : '-';
    },
    scheduleStickyUpdate() {
      if (this.stickyUpdateTimeout) {
        clearTimeout(this.stickyUpdateTimeout);
      }
      this.stickyUpdateTimeout = setTimeout(() => {
        this.stickyUpdateTimeout = null;
        this.updateAllStickyColumns();
      }, 80);
    },
    updateAllStickyColumns() {
      this.$nextTick(() => {
        if (!this.$el) return;
        const containers = this.$el.querySelectorAll('.tier-fact-table');
        containers.forEach(container => this.updateStickyColumns(container));
      });
    },
    updateStickyColumns(container) {
      if (!container || typeof window === 'undefined') return;
      const getWidth = (selector) => {
        const el = container.querySelector(selector);
        if (!el) return 0;
        const rect = el.getBoundingClientRect();
        return rect.width || 0;
      };
      const taskWidth = 200;
      const measuredUnit = Math.max(getWidth('.unit-name-header') || getWidth('.unit-name-cell') || 0, 0);

      const unitWidth = Math.max(measuredUnit || this.measuredSticky.unit, 50);

      const newMeasured = {
        unit: unitWidth,
      };
      this.measuredSticky = newMeasured;

      const taskLeft = 0;
      const unitLeft = taskLeft + taskWidth;

      container.style.setProperty('--task-width', `${taskWidth}px`);
      container.style.setProperty('--task-min-width', `${taskWidth}px`);
      container.style.setProperty('--task-max-width', `${taskWidth}px`);

      container.style.setProperty('--unit-width', `${unitWidth}px`);
      container.style.setProperty('--unit-min-width', `${unitWidth}px`);
      container.style.setProperty('--unit-max-width', `${unitWidth}px`);

      container.style.setProperty('--task-left', `${taskLeft}px`);
      container.style.setProperty('--unit-left', `${unitLeft}px`);
    },
    async addGprRowForVisibleDates(work_group_id, work_group_level_id) {
      // Добавляем строку "Отклонение от ГПР (+/-)" для видимых дат (режим без этажей)
      if (!work_group_id) return;
      
      // Увеличиваем счетчик запросов
      this.gprRequestCounter++;
      const currentRequestId = this.gprRequestCounter;
      
      try {
        // Получаем видимые даты
        const visibleDates = this.visibleDates;
        if (!visibleDates || visibleDates.length === 0) {
          return;
        }
        
        // Собираем массив дат для одного запроса
        const datesArray = visibleDates.map(dateInfo => dateInfo.original);
        
        // Загружаем данные ГПР для всех видимых дат одним запросом
        const gprResults = await getGprValues(work_group_id, datesArray, work_group_level_id);
        
        // Проверяем, не устарел ли этот запрос
        if (currentRequestId !== this.gprRequestCounter) {
          console.log('Ignoring outdated GPR request');
          return; // Пришел более новый запрос, игнорируем этот результат
        }
        
        // Удаляем ВСЕ строки ГПР если есть (на случай дублирования)
        this.rowsData = this.rowsData.filter(row => row.task_name !== 'Отклонение от ГПР (+/-)');
        
        const gprRow = {
          task_name: 'Отклонение от ГПР (+/-)',
          task_dict_id: null,
          unit_name: null,
          is_edit: false, // Строка не редактируема
        };
        
        // Заполняем строку данными для видимых дат
        visibleDates.forEach(dateInfo => {
          const gprValue = gprResults[dateInfo.original];
          if (gprValue !== null && gprValue !== undefined) {
            gprRow[dateInfo.original] = [{
              plan_value: gprValue,
              fact_value: null,
              delta: null,
              fact_dept_value: null,
              fact_value_new: null,
            }];
          } else {
            // Вместо пустого массива ставим 0
            gprRow[dateInfo.original] = [{
              plan_value: 0,
              fact_value: null,
              delta: null,
              fact_dept_value: null,
              fact_value_new: null,
            }];
          }
        });
        
        // Для остальных дат (невидимых) добавляем 0
        if (this.allDates && this.allDates.length > 0) {
          this.allDates.forEach(dateInfo => {
            if (!gprRow[dateInfo.original]) {
              gprRow[dateInfo.original] = [{
                plan_value: 0,
                fact_value: null,
                delta: null,
                fact_dept_value: null,
                fact_value_new: null,
              }];
            }
          });
        }
        
        // Добавляем строку в конец массива
        this.rowsData.push(gprRow);
      } catch (e) {
        console.error('Error adding GPR row:', e);
      }
    },
    async addGprRowForVisibleDatesLevel(work_group_id, work_group_level_id, levelTab) {
      // Добавляем строку "Отклонение от ГПР (+/-)" для видимых дат (режим с этажами)
      if (!work_group_id || !levelTab) return;
      
      // Инициализируем счетчик для этого уровня, если его нет
      if (!levelTab.gprRequestCounter) {
        levelTab.gprRequestCounter = 0;
      }
      
      // Увеличиваем счетчик запросов
      levelTab.gprRequestCounter++;
      const currentRequestId = levelTab.gprRequestCounter;
      
      try {
        // Получаем видимые даты для этого уровня
        const visibleDates = this.getVisibleDatesForLevel(levelTab);
        if (!visibleDates || visibleDates.length === 0) {
          return;
        }
        
        // Собираем массив дат для одного запроса
        const datesArray = visibleDates.map(dateInfo => dateInfo.original);
        
        // Загружаем данные ГПР для всех видимых дат одним запросом
        const gprResults = await getGprValues(work_group_id, datesArray, work_group_level_id);
        
        // Проверяем, не устарел ли этот запрос
        if (currentRequestId !== levelTab.gprRequestCounter) {
          console.log('Ignoring outdated GPR request for level');
          return; // Пришел более новый запрос, игнорируем этот результат
        }
        
        // Удаляем ВСЕ строки ГПР если есть (на случай дублирования)
        levelTab.rowsData = levelTab.rowsData.filter(row => row.task_name !== 'Отклонение от ГПР (+/-)');
        
        const gprRow = {
          task_name: 'Отклонение от ГПР (+/-)',
          task_dict_id: null,
          unit_name: null,
          is_edit: false, // Строка не редактируема
        };
        
        // Заполняем строку данными для видимых дат
        visibleDates.forEach(dateInfo => {
          const gprValue = gprResults[dateInfo.original];
          if (gprValue !== null && gprValue !== undefined) {
            gprRow[dateInfo.original] = [{
              plan_value: gprValue,
              fact_value: null,
              delta: null,
              fact_dept_value: null,
              fact_value_new: null,
            }];
          } else {
            // Вместо пустого массива ставим 0
            gprRow[dateInfo.original] = [{
              plan_value: 0,
              fact_value: null,
              delta: null,
              fact_dept_value: null,
              fact_value_new: null,
            }];
          }
        });
        
        // Для остальных дат (невидимых) добавляем 0
        if (levelTab.allDates && levelTab.allDates.length > 0) {
          levelTab.allDates.forEach(dateInfo => {
            if (!gprRow[dateInfo.original]) {
              gprRow[dateInfo.original] = [{
                plan_value: 0,
                fact_value: null,
                delta: null,
                fact_dept_value: null,
                fact_value_new: null,
              }];
            }
          });
        }
        
        // Добавляем строку в конец массива
        levelTab.rowsData.push(gprRow);
      } catch (e) {
        console.error('Error adding GPR row for level:', e);
      }
    },
    async addFloorsRow(work_group_id) {
      // Добавляем строку "Этажность" которая показывает номера этажей по их периодам
      if (!work_group_id) return;
      
      try {
        // Загружаем данные об этажах
        const levelsData = await getWorkGroupLevelNum(work_group_id);
        if (!levelsData || levelsData.length === 0) return;
        
        // Удаляем старую строку этажности если есть
        this.rowsData = this.rowsData.filter(row => row.task_name !== 'Этажность');
        
        const floorsRow = {
          task_name: 'Этажность',
          task_dict_id: null,
          unit_name: '-',
          is_edit: false, // Строка не редактируема
        };
        
        // Для каждой даты проверяем, в какой период этажа она попадает
        this.allDates.forEach(dateInfo => {
          const currentDate = dateInfo.original; // Формат YYYY-MM-DD
          
          // Находим этажи, период которых включает эту дату
          const floorsForDate = levelsData.filter(level => {
            const levelDateStart = this.normalizeDateForComparison(level.level_date_start || level.date_start);
            const levelDateEnd = this.normalizeDateForComparison(level.level_date_end || level.date_end);
            
            if (!levelDateStart || !levelDateEnd) return false;
            
            // Проверяем, попадает ли текущая дата в период этажа
            return currentDate >= levelDateStart && currentDate <= levelDateEnd;
          }).sort((a, b) => {
            // Сортируем по убыванию level_num (старшие этажи сверху)
            const numA = a.level_num !== null && a.level_num !== undefined ? a.level_num : -Infinity;
            const numB = b.level_num !== null && b.level_num !== undefined ? b.level_num : -Infinity;
            return numB - numA;
          });
          
          // Если есть этажи для этой даты, отображаем их (только номер без дат)
          if (floorsForDate.length > 0) {
            floorsRow[currentDate] = floorsForDate.map(floor => {
              // Извлекаем только номер этажа, если пришла строка с датами
              let levelNum = floor.level_num;
              if (levelNum && typeof levelNum === 'string') {
                const match = levelNum.match(/^(\d+)/);
                if (match) {
                  levelNum = parseInt(match[1]);
                }
              }
              
              return {
                plan_value: levelNum !== null && levelNum !== undefined ? levelNum : '',
                fact_value: null,
                delta: null,
                fact_dept_value: null,
                fact_value_new: null,
              };
            });
          } else {
            floorsRow[currentDate] = [];
          }
        });
        
        // Добавляем строку в конец массива
        this.rowsData.push(floorsRow);
      } catch (e) {
        console.error('Error adding floors row:', e);
      }
    },
    normalizeDateForComparison(dateStr) {
      // Приводим дату к формату YYYY-MM-DD для сравнения
      if (!dateStr) return null;
      
      try {
        let date;
        if (dateStr.includes('T')) {
          // ISO формат с временем
          date = new Date(dateStr);
        } else if (dateStr.includes('.')) {
          // Формат DD.MM.YYYY
          const parts = dateStr.split('.');
          date = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
        } else if (dateStr.includes('-')) {
          // Формат YYYY-MM-DD (уже нормализован)
          const parts = dateStr.split('-');
          if (parts.length === 3) {
            return dateStr; // Уже в нужном формате
          }
          date = new Date(dateStr);
        } else {
          date = new Date(dateStr);
        }
        
        if (isNaN(date.getTime())) return null;
        
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        
        return `${year}-${month}-${day}`;
      } catch (e) {
        console.error('Error normalizing date:', e);
        return null;
      }
    },
    async setInitialVisibleRange(work_group_id) {
      // Определяем начальный диапазон на основе этажей или плана
      if (!this.allDates || this.allDates.length === 0) {
        this.visibleStartIndex = 0;
        this.visibleEndIndex = 0;
        return;
      }
      
      try {
        // Загружаем данные об этажах
        const levelsData = await getWorkGroupLevelNum(work_group_id);
        
        let startDate = null;
        let endDate = null;
        
        if (levelsData && levelsData.length > 0) {
          // Если есть этажи - находим минимальную дату начала и максимальную дату окончания
          const allLevelDates = levelsData.map(level => ({
            start: this.normalizeDateForComparison(level.level_date_start || level.date_start),
            end: this.normalizeDateForComparison(level.level_date_end || level.date_end)
          })).filter(d => d.start && d.end);
          
          if (allLevelDates.length > 0) {
            startDate = allLevelDates.reduce((min, d) => !min || d.start < min ? d.start : min, null);
            endDate = allLevelDates.reduce((max, d) => !max || d.end > max ? d.end : max, null);
          }
        }
        
        // Если этажей нет или даты не найдены - используем даты из плана
        if (!startDate || !endDate) {
          // Ищем минимальную и максимальную даты с данными в плане
          const datesWithData = [];
          
          this.rowsData.forEach(row => {
            if (row.task_name === 'Отклонение от ГПР (+/-)' || row.task_name === 'Этажность') {
              return; // Пропускаем служебные строки
            }
            
            this.allDates.forEach(dateInfo => {
              const items = row[dateInfo.original];
              if (items && Array.isArray(items) && items.length > 0) {
                const hasData = items.some(item => 
                  (item.plan_value !== null && item.plan_value !== undefined && item.plan_value !== '') ||
                  (item.fact_value !== null && item.fact_value !== undefined && item.fact_value !== '')
                );
                if (hasData) {
                  datesWithData.push(dateInfo.original);
                }
              }
            });
          });
          
          if (datesWithData.length > 0) {
            const uniqueDates = [...new Set(datesWithData)].sort();
            startDate = uniqueDates[0];
            endDate = uniqueDates[uniqueDates.length - 1];
          }
        }
        
        // Если нашли диапазон дат, устанавливаем его
        if (startDate && endDate) {
          const startIndex = this.allDates.findIndex(d => d.original === startDate);
          const endIndex = this.allDates.findIndex(d => d.original === endDate);
          
          if (startIndex >= 0 && endIndex >= 0) {
            this.visibleStartIndex = startIndex;
            this.visibleEndIndex = endIndex;
            return;
          }
        }
        
        // Если ничего не нашли, показываем окно вокруг текущей даты
        let todayIndex = this.allDates.findIndex(d => d.original === this.todayDate);
        if (todayIndex < 0) {
          todayIndex = Math.floor(this.allDates.length / 2);
        }
        this.visibleStartIndex = Math.max(0, todayIndex - 7);
        this.visibleEndIndex = Math.min(this.allDates.length - 1, todayIndex + 1);
      } catch (e) {
        console.error('Error setting initial visible range:', e);
        // По умолчанию показываем окно вокруг текущей даты
        let todayIndex = this.allDates.findIndex(d => d.original === this.todayDate);
        if (todayIndex < 0) {
          todayIndex = Math.floor(this.allDates.length / 2);
        }
        this.visibleStartIndex = Math.max(0, todayIndex - 7);
        this.visibleEndIndex = Math.min(this.allDates.length - 1, todayIndex + 1);
      }
    },
  },
  setup() {
    const { showModal, closeModal } = useAppStore();
    const { showSucceedSnackbar } = useCustomSnackbar();
    return { showModal, closeModal, showSucceedSnackbar };
  }
}
</script>

<style scoped lang="scss">
.filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  margin-bottom: 25px;

  &__item {
    min-width: 150px;
    
    // Убираем курсор блокировки для disabled селектов
    :deep(.q-field--disabled) {
      cursor: default !important;
      
      .q-field__control {
        cursor: default !important;
      }
      
      .q-field__native {
        cursor: default !important;
      }
      
      .q-field__append {
        cursor: default !important;
      }
      
      .q-icon {
        cursor: default !important;
      }
    }
    
    // Убираем курсор блокировки для всех элементов внутри селектов
    :deep(.q-field) {
      .q-field__append {
        .q-icon {
          cursor: pointer !important;
        }
      }
    }
    
    :deep(.q-field--disabled) {
      .q-field__append {
        .q-icon {
          cursor: default !important;
        }
      }
    }
  }
}

.table-header-with-nav {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 0;
  background-color: #f5f5f5;
  border-radius: 4px 4px 0 0;
  margin-bottom: 0;
  
  .table-title {
    font-size: 18px;
    font-weight: 600;
    color: #4caf50;
    min-width: 150px;
    text-align: center;
  }
  
  .nav-btn {
    color: #1976d2;
    transition: all 0.2s ease;
    
    &:hover:not(:disabled) {
      background-color: rgba(25, 118, 210, 0.1);
      transform: scale(1.1);
    }
    
    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
}

.table-container {
  width: 100%;
  position: relative;
  
  // Контейнер для таблицы с горизонтальным скроллом
  .table-wrapper {
    width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    // Стандартный скроллбар браузера - без кастомных стилей
  }
}

.tier-fact-table {
  --task-width: 250px;
  --task-min-width: 250px;
  --task-max-width: 250px;
  --plan-width: 70px;
  --plan-min-width: 70px;
  --plan-max-width: 70px;
  --fact-width: 70px;
  --fact-min-width: 70px;
  --fact-max-width: 70px;
  --unit-width: 50px;
  --unit-min-width: 50px;
  --unit-max-width: 50px;
  
  --task-left: 0px;
  --unit-left: calc(var(--task-left) + var(--task-width));
  
  :deep(.q-table) {
    border-collapse: collapse;
    table-layout: fixed;
    width: auto !important;
  }
  
  :deep(.q-table th),
  :deep(.q-table td) {
    padding: 0;
    border-spacing: 0;
  }
  
  :deep(.q-table tbody tr) {
    height: 0;
  }
  
  :deep(.q-table thead tr) {
    height: 24px !important;
  }
  
  :deep(.q-table th.plan-fact-header),
  :deep(.q-table th.day-header),
  :deep(.q-table th.month-header),
  :deep(.q-table th.month-total-header) {
    padding: 1px 2px !important;
    line-height: 1 !important;
    height: auto !important;
    min-height: unset !important;
    max-height: none !important;
  }
  
  :deep(.q-table__title) {
    color: #4caf50;
    font-weight: 600;
  }
}

// Грид для разделения ячейки
.date-cell-grid {
  display: grid;
  width: 100%;
  height: 100%;
  gap: 0;
  
  &.simple {
    // Простой режим: 1 ячейка (только plan_value)
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    min-height: 36px;
  }
  
  &.detailed {
    // Детальный режим: 2x2 ячейки
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    min-height: 64px;
  }
}

// Новая структура: вертикальная компоновка для План/Факт
.date-cell-content-vertical {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  line-height: normal;
  font-size: 11px;
}

.plan-fact-grid {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 0;
  flex: 1;
  
  .grid-cell {
    flex: 1;
    padding: 0;
    margin: 0;
    
    &:first-child {
      border-bottom: 1px solid #616161;
    }
  }
}

// Заголовки П/Ф
.plan-fact-header {
  font-size: 11px;
  font-weight: 700;
  padding: 1px 2px !important;
  background-color: #FFE699 !important;
  color: #000000 !important;
  border: 1px solid #424242 !important;
  line-height: 1;
  height: auto;
}

// Колонки План и Факт
.plan-column {
  border-right: 1px solid #424242 !important;
}

.fact-column {
  border-left: 1px solid #424242 !important;
}

.grid-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  border: none;
  line-height: 1;
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

// План всегда серый
.plan-cell {
  background-color: #bdbdbd;
  color: #212121;
  
  &.single {
    // Одна ячейка на всю ширину
    grid-column: 1;
    grid-row: 1;
  }
}

// Факт - зеленый или красный
.fact-cell {
  background-color: #f5f5f5;
  color: #212121;
  
  &.fact-green {
    background-color: #4caf50;
    color: white;
  }
  
  &.fact-red {
    background-color: #f44336;
    color: white;
  }
  
  &.fact-grey {
    background-color: #bdbdbd;
    color: #212121;
  }
}

.task-name-header {
  background-color: #f5f5f5;
  width: var(--task-width);
  min-width: var(--task-min-width);
  max-width: var(--task-max-width);
  position: sticky;
  left: var(--task-left);
  z-index: 10;
  box-sizing: border-box;
}

.task-name-cell {
  width: var(--task-width);
  min-width: var(--task-min-width);
  max-width: var(--task-max-width);
  position: sticky;
  left: var(--task-left);
  z-index: 5;
  background-color: white;
  box-sizing: border-box;
}

.report-plan-header {
  background-color: #1976d2;
  text-align: center;
  font-weight: 600;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  position: sticky;
  left: var(--plan-left);
  z-index: 10;
  box-sizing: border-box;
  width: var(--plan-width);
  min-width: var(--plan-min-width);
  max-width: var(--plan-max-width);
}

.report-fact-header {
  background-color: #34C759;
  text-align: center;
  font-weight: 600;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  position: sticky;
  left: var(--fact-left);
  z-index: 10;
  box-sizing: border-box;
  width: var(--fact-width);
  min-width: var(--fact-min-width);
  max-width: var(--fact-max-width);
}

.report-plan-cell {
  width: var(--plan-width);
  min-width: var(--plan-min-width);
  max-width: var(--plan-max-width);
  text-align: center;
  font-weight: 500;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  position: sticky;
  left: var(--plan-left);
  z-index: 5;
  background-color: #E3F2FD;
  box-sizing: border-box;
}

.report-fact-cell {
  width: var(--fact-width);
  min-width: var(--fact-min-width);
  max-width: var(--fact-max-width);
  text-align: center;
  font-weight: 500;
  border-left: 1px solid #e0e0e0;
  border-right: 1px solid #e0e0e0;
  position: sticky;
  left: var(--fact-left);
  z-index: 5;
  background-color: #E8F5E9;
  box-sizing: border-box;
}

.unit-name-header {
  background-color: #f5f5f5;
  width: var(--unit-width);
  min-width: var(--unit-min-width);
  max-width: var(--unit-max-width);
  position: sticky;
  left: var(--unit-left);
  z-index: 10;
  text-align: center;
  box-sizing: border-box;
  border-left: 1px solid #e0e0e0;
}

.unit-name-cell {
  width: var(--unit-width);
  min-width: var(--unit-min-width);
  max-width: var(--unit-max-width);
  position: sticky;
  left: var(--unit-left);
  z-index: 5;
  background-color: white;
  text-align: center;
  box-sizing: border-box;
  border-left: 1px solid #e0e0e0;
}

.month-header {
  text-align: center;
  font-weight: 600;
  background-color: #f5f5f5;
  border-left: 2px solid #1976d2;
  border-right: 2px solid #1976d2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 1px 2px !important;
  line-height: 1;
  height: auto;
}

.month-divider {
  width: 2px;
  min-width: 2px;
  max-width: 2px;
  background-color: #1976d2;
  padding: 0 !important;
  border: none !important;
}

.month-divider-cell {
  width: 2px;
  min-width: 2px;
  max-width: 2px;
  background-color: #e0e0e0;
  padding: 0 !important;
  border-left: 2px solid #1976d2;
  border-right: 2px solid #1976d2;
}

.month-total-header {
  background-color: #FFE699 !important;
  font-weight: 700;
  font-size: 10px;
  border: 1px solid #424242 !important;
  padding: 1px 2px !important;
  line-height: 1;
  height: auto;
}

.month-total-cell {
  font-weight: 700;
  border-left: 2px solid #1976d2 !important;
}

.day-header {
  font-weight: 500;
  background-color: #fafafa;
  min-width: 80px;
  width: 80px;
  max-width: 80px;
  text-align: center;
  white-space: nowrap;
  padding: 1px 2px !important;
  line-height: 1;
  height: auto;
}

.date-cell {
  border: 2px solid #424242;
  min-width: 40px;
  width: 40px;
  max-width: 40px;
  text-align: center;
  padding: 0 !important;
  margin: 0;
  vertical-align: top;
  height: 100%;
  line-height: 0;
  font-size: 0;
  box-sizing: border-box;
}

.date-cell-content {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  height: 100%;
}

.date-cell .text-grey-5 {
  display: inline-block;
}

.clickable-cell {
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #f0f0f0;
  }
}

.non-editable-cell {
  cursor: not-allowed;
  opacity: 0.7;
  
  &:hover {
    background-color: transparent;
  }
}

.highlighted-row {
  background-color: #e8f5e9 !important;
  
  &--first {
    border-top: 3px solid #4caf50 !important;
  }
  
  &--last {
    border-bottom: 3px solid #4caf50 !important;
    margin-bottom: 2px; // Дополнительный отступ для последней строки, чтобы скроллбар не налезал
  }
  
  .task-name-cell,
  .unit-name-cell {
    background-color: #e8f5e9 !important;
  }
  
  .report-plan-cell {
    background-color: #BBDEFB !important;
  }
  
  .report-fact-cell {
    background-color: #C8E6C9 !important;
  }
  
  td {
    background-color: #e8f5e9 !important;
  }
  
  &:hover {
    background-color: #c8e6c9 !important;
    
    .task-name-cell,
    .unit-name-cell {
      background-color: #c8e6c9 !important;
    }
    
    .report-plan-cell {
      background-color: #90CAF9 !important;
    }
    
    .report-fact-cell {
      background-color: #A5D6A7 !important;
    }
    
    td {
      background-color: #c8e6c9 !important;
    }
  }
}

.gpr-row {
  background-color: #fff3e0 !important;
  border-top: 2px solid #ff9800 !important;
  border-bottom: 2px solid #ff9800 !important;
  font-weight: 600;
  font-size: 16px; // Увеличенный размер шрифта
  
  .task-name-cell,
  .unit-name-cell {
    background-color: #fff3e0 !important;
    font-size: 16px; // Увеличенный размер шрифта
  }
  
  .report-plan-cell {
    background-color: #ffe0b2 !important;
    font-size: 16px; // Увеличенный размер шрифта
  }
  
  .report-fact-cell {
    background-color: #ffe0b2 !important;
    font-size: 16px; // Увеличенный размер шрифта
  }
  
  td {
    background-color: #fff3e0 !important;
    font-size: 16px; // Увеличенный размер шрифта
  }
  
  // Увеличиваем шрифт в ячейках с данными
  .grid-cell {
    font-size: 14px; // Увеличенный размер для значений в ячейках
    font-weight: 700;
  }
  
  &:hover {
    background-color: #ffe0b2 !important;
    
    .task-name-cell,
    .unit-name-cell {
      background-color: #ffe0b2 !important;
    }
    
    .report-plan-cell {
      background-color: #ffcc80 !important;
    }
    
    .report-fact-cell {
      background-color: #ffcc80 !important;
    }
    
    td {
      background-color: #ffe0b2 !important;
    }
  }
}

// Цветовая индикация для ячеек ГПР
.gpr-ahead {
  background-color: #2196F3 !important; // Синий - опережение
  color: white !important;
  font-weight: 700;
}

.gpr-on-schedule {
  background-color: #4caf50 !important; // Зеленый - по графику
  color: white !important;
  font-weight: 700;
}

.gpr-behind {
  background-color: #f44336 !important; // Красный - опоздание
  color: white !important;
  font-weight: 700;
}

// Стиль для объединённой итоговой ячейки ГПР
.gpr-total-cell {
  font-size: 16px !important;
  font-weight: 700 !important;
}

// Стили для ячеек ГПР (объединённые П/Ф)
.gpr-cell-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
}

.gpr-value {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  line-height: 1;
}

.floors-row {
  background-color: #e8eaf6 !important;
  border-top: 2px solid #3f51b5 !important;
  border-bottom: 2px solid #3f51b5 !important;
  font-weight: 600;
  font-size: 14px;
  
  .task-name-cell,
  .unit-name-cell {
    background-color: #e8eaf6 !important;
    font-size: 14px;
  }
  
  .report-plan-cell {
    background-color: #c5cae9 !important;
    font-size: 14px;
  }
  
  .report-fact-cell {
    background-color: #c5cae9 !important;
    font-size: 14px;
  }
  
  td:not(.floor-cell):not(.floor-cell-empty) {
    background-color: #e8eaf6 !important;
    font-size: 14px;
  }
  
  // Стили для ячеек этажности
  .floor-cell {
    font-weight: 600;
    font-size: 11px;
    color: white !important;
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    border: 2px solid rgba(255, 255, 255, 0.3) !important;
    vertical-align: middle;
    height: 24px;
    padding: 2px 6px !important;
    cursor: default !important;
    line-height: 1.1;
    // НЕ задаём background-color здесь, чтобы инлайн-стиль работал
    
    .floor-label {
      display: inline-block;
      padding: 2px 6px;
      border-radius: 2px;
      background-color: rgba(0, 0, 0, 0.15);
      font-weight: 600;
      letter-spacing: 0.2px;
      line-height: 1.1;
      white-space: nowrap;
      font-size: 1.8em; // Увеличиваем весь текст (и цифру, и слово)
      
      .floor-word {
        font-size: 1.1em; // Немного больше относительно базового размера
        font-weight: 700;
      }
    }
    
    &:hover {
      opacity: 0.9;
    }
  }
  
  .floor-cell-empty {
    background-color: #f5f5f5 !important;
    height: 24px;
    padding: 2px 6px !important;
    cursor: default !important;
    border: 2px solid #e0e0e0 !important;
  }
  
  &:hover {
    background-color: #c5cae9 !important;
    
    .task-name-cell,
    .unit-name-cell {
      background-color: #c5cae9 !important;
    }
    
    .report-plan-cell {
      background-color: #9fa8da !important;
    }
    
    .report-fact-cell {
      background-color: #9fa8da !important;
    }
    
    td:not(.floor-cell) {
      background-color: #c5cae9 !important;
    }
  }
}

.no-data {
  padding: 40px;
  text-align: center;
  color: #999;
  font-size: 16px;
}

.levels-accordion {
  margin-top: 20px;
  
  .q-list {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
  }
}

.level-accordion-header {
  background-color: #f5f5f5;
  font-weight: 600;
  min-height: 50px;
  cursor: pointer !important;
  
  &:hover {
    background-color: #e0e0e0;
  }
}

// Убираем курсор блокировки со всех элементов аккордеона
.levels-accordion {
  :deep(.q-expansion-item__container) {
    cursor: pointer !important;
    
    .q-item {
      cursor: pointer !important;
    }
    
    .q-icon {
      cursor: pointer !important;
    }
  }
}

.level-table-container {
  padding: 20px;
  background-color: #fafafa;
}

.level-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
}

.date-cell--today {
  position: relative;
  background-color: #ffebee !important;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background-color: #e53935;
    z-index: 1;
  }
}

.date-cell--month-first {
  border-left: 2px solid #1976d2 !important;
}

.date-cell--month-last {
  border-right: 2px solid #1976d2 !important;
}

.day-header--month-first {
  border-left: 2px solid #1976d2 !important;
}

.day-header--month-last {
  border-right: 2px solid #1976d2 !important;
}
</style>

